const ReportTypeFields = {
  rentalDurationByTypeReport: { value: "rentalDurationByTypeReport", name: "Długość wypożyczeń według typu roweru" },
  clientFundsReport: { value: "clientFundsReport", name: "Rozliczenie środków klientów" },
  seasonReport: { value: "seasonReport", name: "Sezonowy" },
  monthlyReport: { value: "monthlyReport", name: "Okresowy" },
  dayByDayAccountingReport: {
    value: "dayByDayAccountingReport",
    name: "Księgowy dobowy",
  },
  rentalByRentalAccountingReport: {
    value: "rentalByRentalAccountingReport",
    name: "Księgowy szczegółowy",
  },
  monthlyAccountingReport: {
    value: "monthlyAccountingReport",
    name: "Księgowy miesięczny",
  },
  customReportFromTemplate: {
    value: "customReportFromTemplate",
    name: "Własny",
  },
  userFundsAvailableToWithdraw: {
    value: "userFundsAvailableToWithdraw",
    name: "Depozyty userów dostępne do wypłacenia",
  },
  specialDepositWithdrawalReport: {
    value: "specialDepositWithdrawalReport",
    name: "Wypłaty depozytów",
  },
  userBikeLeftInZoneBonusReport: {
    value: "userBikeLeftInZoneBonusReport",
    name: "Bonusy użytkowników uzyskane za zwrócenie roweru",
  },
  complaintsReport: { value: "complaintsReport", name: "Reklamacje" },
  ridersReport: { value: "ridersReport", name: "Raport przejazdów" },
  debtCollectionReport: {
    value: "debtCollectionReport",
    name: "Raport windykacyjny",
  },
  totalDistanceByUserReport: {
    value: "totalDistanceByUserReport",
    name: "Lista przejechanego dystansu przez użytkowników",
  },
  serviceSummaryReport: {
    value: "serviceSummaryReport",
    name: "Serwis - podsumowanie",
  },
  bikesInSystemReport: {
    value: "bikesInSystemReport",
    name: "Liczby rowerów w systemie",
  },
  monthlyBikesReport: {
    value: "monthlyBikesReport",
    name: "Liczby rowerów - raport miesięczny",
  },
  yearlyBikesReport: {
    value: "yearlyBikesReport",
    name: "Liczby rowerów - raport roczny",
  },
  hourlyRentalsReport: { value: "hourlyRentalsReport", name: "Średnia liczba wypożyczeń według godzin i dni tygodnia" },
  stationConnectionsReport: { value: "stationConnectionsReport", name: "Najpopularniejsze połączenia między stacjami" },
  bikeDefectsReport: { value: "bikeDefectsReport", name: "Usterki rowerów według typu" },
  hourlyRentalDurationReport: { value: "hourlyRentalDurationReport", name: "Średni czas wypożyczeń według godzin i dni tygodnia" },
  stationPopularityReport: { value: "stationPopularityReport", name: "Popularność stacji - wypożyczenia i zwroty" },
  dailyReport: {
    value: "dailyReport",
    name: "Raport dzienny",
  },
  braMonthlyAccountingReport: {
    value: "braMonthlyAccountingReport",
    name: "Miesięczne zestawienie opłat i kar",
  },
  braPeriodicFinancialReport: {
    value: "braPeriodicFinancialReport",
    name: "Okresowe zestawienie wpłat, opłat, taryf i abonamentów",
  },
  adjustmentReport: { value: "adjustmentReport", name: "Raport korekt" },

  specialReport1: { value: "specialReport1", name: "Dedykowany" },

  specialGlobalReport: {
    value: "specialGlobalReport",
    name: "Globalny (roczny)",
  },
  specialMonthlyAccountingReport: {
    value: "specialMonthlyAccountingReport",
    name: "Raport zbiorczy",
  },
  specialGlobalReportUserDebit: {
    value: "specialGlobalReportUserDebit",
    name: "Debety userów",
  },
  globalUserAvailableFundsDepositReport: {
    value: "globalUserAvailableFundsDepositReport",
    name: "Depozyty dostępne do wypłacenia",
  },
  tenantUserDebitReportPerTenant: {
    value: "tenantUserDebitReport",
    name: "Debety userów (Per tenant)",
  },
  tenantUserDebitReportDefault: {
    value: "tenantUserDebitReport",
    name: "Debety userów",
  },
  sportCardExpiredAmount: {
    value: "sportCardExpiredAmount",
    name: "Wygasłe środki na karcie sportowej",
  },
  medicoverStatisticReport: {
    value: "medicoverStatisticReport",
    name: "Statystyki Medicover Sport",
  },
  medicoverWithdrawalReport: {
    value: "medicoverWithdrawalReport",
    name: "Statystyki wypłat Medicover Sport",
  },
  globalDebtCollectionReport: {
    value: "globalDebtCollectionReport",
    name: "Raport windykacyjny (Globalny)",
  },
};

export default ReportTypeFields;
